module.exports = __webpack_public_path__ + "img/aufzughelden-device-md.b3b9489e.svg";